import NiceModal from '@ebay/nice-modal-react'

import { PricingTableModal } from './PricingTable'

export const showPricingTableModal = (
  props: { customerSessionClientSecret?: string } = {},
) => {
  NiceModal.show(PricingTableModal, props)
}
